class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector(".m-main-product");
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    addEventDelegate({
      context: this.container,
      selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(MinimogSettings.productHandle) === -1) {
      products.unshift(MinimogSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();

/* MAYDAN_13BD002WFM_RAM_INTERFACE_FIX_20260509
 * Temporary storefront guard for cached product pages: ensure validated RAM is visible
 * and remove obsolete Interface line for SKU 13BD002WFM only.
 */
(function maydan13bd002wfmCharacteristicsFix() {
  var TARGET_HANDLE = 'lenovo-desktop-tower-neo-50t-u5-8g-core-ultra-5-225-13bd002wfm';
  var TARGET_SKU = '13BD002WFM';
  var RAM_VALUE = '8 Go DDR5-5600 (1 x 8 Go UDIMM)';

  function isTargetProduct() {
    var settings = window.MinimogSettings || {};
    var handle = settings.productHandle || '';
    var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!handle && pathMatch) handle = pathMatch[1];
    if (handle === TARGET_HANDLE) return true;
    return document.documentElement.innerHTML.indexOf(TARGET_SKU) !== -1 && window.location.pathname.indexOf('/products/') !== -1;
  }

  function textOf(el) {
    return (el && (el.textContent || el.innerText) || '').replace(/\s+/g, ' ').trim();
  }

  function fixBlock(ul) {
    if (!ul) return;
    var items = Array.prototype.slice.call(ul.querySelectorAll('li'));
    items.forEach(function(li) {
      var txt = textOf(li);
      if (/^Interface\s*:/.test(txt) || txt.indexOf('Ethernet RJ-45, HDMI 2.1, DisplayPort 1.4, VGA, USB-C, USB-A, audio') !== -1) {
        li.remove();
      }
    });

    items = Array.prototype.slice.call(ul.querySelectorAll('li'));
    var hasRam = items.some(function(li) { return /^RAM\s*:/.test(textOf(li)); });
    if (hasRam) return;

    var ramLi = document.createElement('li');
    ramLi.innerHTML = '<strong>RAM :</strong> ' + RAM_VALUE;
    var cpuLi = items.find(function(li) { return /^(CPU|Processeur)\s*:/.test(textOf(li)); });
    if (cpuLi && cpuLi.nextSibling) {
      ul.insertBefore(ramLi, cpuLi.nextSibling);
    } else if (cpuLi) {
      ul.appendChild(ramLi);
    } else {
      ul.appendChild(ramLi);
    }
  }

  function run() {
    if (!isTargetProduct()) return;
    Array.prototype.slice.call(document.querySelectorAll('.custom-metafields ul')).forEach(fixBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 500);
  setTimeout(run, 1500);
})();
